import _ from 'lodash'
import Vue from 'vue'
import { merchantStore } from '@/store/merchant'
import { createClient } from './http'
import { tokenStore } from '@/store/token'

const client = createClient({ tokenStore })

export const API = {
  client: client,
  async call(method, payload = {}) {
    if (!_.isNil(merchantStore.merchantId)) {
      payload.merchant_id = merchantStore.merchantId
    }
    try {
      const response = await client.post(`/${method}`, payload)
      return response.data
    } catch (error) {
      Vue.toasted.error(error.message)
      throw error
    }
  },
  async upload(method, file, payload = {}) {
    var formData = new FormData()
    formData.append('file', file)
    if (!_.isNil(merchantStore.merchantId)) {
      payload.merchant_id = merchantStore.merchantId
    }
    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value)
    })
    try {
      const response = await client.post(`/${method}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return response.data
    } catch (error) {
      Vue.toasted.error(error.message)
      throw error
    }
  },
  urlForImage({ key, token }) {
    if (!(key && token)) {
      return null
    }
    return `/api/v1/resource.image/${key}?token=${token}`
  },
}
